import type { ReactNode } from "react";
import { DialogHeader } from "./DialogHeader";
import { LanguageSwitch, type ContentLanguage } from "./LanguageSwitch";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el encabezado del editor
// (eyebrow + título + selector de idioma) era el mismo marcado palabra por
// palabra en BenefitsScreen.tsx y RewardsScreen.tsx — solo el indicador de
// estado a la derecha difiere (un `Toggle` en Beneficios, un `stat` en
// Recompensas), por eso queda como `statusIndicator`. Extracción sin cambio
// de comportamiento ni de valores visuales.
export function EditorHeader({
  eyebrow,
  title,
  language,
  onLanguageChange,
  statusIndicator,
}: {
  eyebrow: string;
  title: string;
  language: ContentLanguage;
  onLanguageChange: (language: ContentLanguage) => void;
  statusIndicator: ReactNode;
}) {
  // Revisión en vivo 2026-09-22, puntos #3/#4A: este encabezado ya no dibuja
  // su propio `padding` ni su `border-bottom`. Los pone la región `header`
  // del `Modal` (`values.modalRegions.headerPadding`), que es la que además
  // lo deja FIJO mientras el cuerpo se desplaza. Mantenerlos acá daba dos
  // divisores y un padding doble (24 del panel + 24 propios = 48), porque el
  // editor vivía dentro de un `Modal` en su forma histórica. Sus cuatro
  // llamadores —Recompensas, Beneficios, Ofertas y Plantillas— se cambiaron
  // en la misma corrida: no se podía converger uno solo.
  // Punto #21 (misma revisión): eyebrow + título viven en `DialogHeader`, el
  // encabezado común de todos los diálogos; el DOM que sale de acá no cambió.
  return (
    <DialogHeader
      eyebrow={eyebrow}
      title={title}
      aside={
        <>
          <LanguageSwitch value={language} onChange={onLanguageChange} />
          {statusIndicator}
        </>
      }
    />
  );
}
